import { api } from '@/api/client'

export interface BrandColors {
  primary?: string    // hex #rrggbb
  accent?: string
  secondary?: string
  bg?: string
  text?: string
}

export const DEFAULT_COLORS: Required<BrandColors> = {
  primary:   '#404eed',
  accent:    '#f3631c',
  secondary: '#6470f8',
  bg:        '#ecf0fa',
  text:      '#1a1e36',
}

type ColorsResponse = { success: boolean; data: BrandColors }

export async function fetchBrandColors(): Promise<BrandColors> {
  const { data } = await api.get<ColorsResponse>('/admin/themes/colors')
  return data.data ?? {}
}

export async function updateBrandColors(colors: BrandColors): Promise<BrandColors> {
  const { data } = await api.put<ColorsResponse>('/admin/themes/colors', { colors })
  return data.data
}

/** Convert #rrggbb → "r g b" RGB triple (for CSS vars used by Tailwind) */
export function hexToRgbTriple(hex: string): string {
  const clean = hex.replace('#', '')
  const r = parseInt(clean.slice(0, 2), 16)
  const g = parseInt(clean.slice(2, 4), 16)
  const b = parseInt(clean.slice(4, 6), 16)
  return `${r} ${g} ${b}`
}

export function applyColorsToDocument(colors: BrandColors) {
  const resolved = { ...DEFAULT_COLORS, ...colors }
  const root = document.documentElement
  const isDark = root.classList.contains('dark')

  root.style.setProperty('--color-main',       hexToRgbTriple(resolved.primary))
  root.style.setProperty('--color-main-light',  hexToRgbTriple(resolved.secondary))
  root.style.setProperty('--color-accent',      hexToRgbTriple(resolved.accent))

  // Dark modda color-shell inline set edilmezse, .dark kuralındaki değer (--color-shell: 20 27 45) geçerli olur.
  // Açık modda ise API'den gelen / varsayılan bg (#ecf0fa) kullanılır.
  if (!isDark) {
    root.style.setProperty('--color-shell', hexToRgbTriple(resolved.bg))
  } else {
    root.style.removeProperty('--color-shell')
  }

  root.style.setProperty('--brand-primary-hex', resolved.primary)
  root.style.setProperty('--brand-accent-hex',  resolved.accent)
}
